import { createSlice } from '@reduxjs/toolkit';
import { getEventListThunk, getEventMetaThunk } from './Event.thunk';
import { Notification } from '../Notification/NotificationType';

export const eventSlice = createSlice({
  name: 'event',
  initialState: {
    meta: {
      items: {},
      loading: true,
    },
    list: {
      items: [],
      loading: true,
    },
  },
  reducers: {
    resetEventList: state => ({
      ...state,
      list: {
        ...state.list,
        items: [],
        loading: true,
      },
    }),
  },
  extraReducers: builder => {
    // Start Event meta
    builder.addCase(getEventMetaThunk.pending, (state, action) => {
      state.meta = { ...state.meta, loading: true };
    });
    builder.addCase(getEventMetaThunk.fulfilled, (state, action) => {
      const { meta } = action.payload;
      state.meta = { ...state.meta, items: meta, loading: false };
    });
    builder.addCase(getEventMetaThunk.rejected, (state, action) => {
      // state.meta = { ...state.meta, loading: false };
    });
    // End Event meta
    builder.addCase(getEventListThunk.pending, (state, action) => ({
      ...state,
      list: {
        ...state.list,
        loading: true,
      },
    }));
    builder.addCase(getEventListThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.list = {
        ...state.list,
        items: data,
        loading: false,
      };
    });
    builder.addCase(getEventListThunk.rejected, (state, action) => ({
      ...state,
      list: {
        ...state.list,
        loading: false,
      },
    }));
  },
});

export const { resetEventList } = eventSlice.actions;
export const getEventMeta = (state: any) => state.event.meta;
export const getEventList = (state: any): Notification[] =>
  state.event.list?.items || [];

export default eventSlice.reducer;
